import { AABBModel } from './AABBModel';

export enum BorderTypeEnum {
    none = 'none',
    line_c = 'line_c',
    line_r = 'line_r',
    line_l = 'line_l',
    angle = 'angle',
    angle2 = 'angle2'
}

export class BorderModel extends AABBModel {
    public type: BorderTypeEnum = BorderTypeEnum.none;
    public roomIndex: string = '';
    public visible: boolean = true;
    public width: number = 0;
    public height: number = 0;
    public isOnTop: boolean = false;

    public constructor() {
        super();
    }
}
